/**
 * Created by Bob.Gear on 3/05/14.
 */
//------------------------------------------------------------------------
//  projectLocationFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('projectLocationFilterController', ['$scope', '$q', 'lookupTables',
      function ($scope, $q, lookupTables) {
        $scope.componentName = "projectLocationFilter";

        $scope.regions = lookupTables.regions();
        $scope.countries = lookupTables.countries();
        $scope.localities = [];

        $scope.hideRegionSelector = $scope.regions.length === 0;

        $scope.resetFilter = function () {
          $scope.criteria.locationMode = "";
          clearRegionSelections();
          clearCountrySelections();
        };

        var clearRegionSelections = function () {
          if($scope.criteria.selectedRegions) $scope.criteria.selectedRegions.length = 0;
          delete $scope.criteria["selectedRegions"];
        };

        var clearCountrySelections = function () {
          if($scope.criteria.selectedCountries) $scope.criteria.selectedCountries.length=0;
          delete $scope.criteria["selectedCountries"];
        };

        $scope.removeProjectLocationFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#projectLocationFilter");
        };

        $scope.$watch("criteria.selectedRegions.length", function () {
          if (!$scope.criteria.selectedRegions) return;

          $scope.selectedRegionCount = $scope.criteria.selectedRegions.length;
          $scope.regionPlural = ($scope.selectedRegionCount === 1) ? "" : "s";
        });
        $scope.$watch("criteria.selectedCountries.length", function () {
          if (!$scope.criteria.selectedCountries) return;

          $scope.selectedCountryCount = $scope.criteria.selectedCountries.length;
          $scope.countryPlural = ($scope.selectedCountryCount === 1) ? "y" : "ies";
        });

        var asc = function(field) {
          return function(a, b) {
            if (a[field] < b[field]) return -1;
            if (a[field] > b[field]) return 1;
            return 0;
          };
        };

        var desc = function(field) {
          return function(a, b) {
            if (a[field] > b[field]) return -1;
            if (a[field] < b[field]) return 1;
            return 0;
          };
        };

        $scope.$watch("criteria.selectedCountries",
          function(newValue, oldValue) {
            $scope.localities = [];

            if (!newValue) return;
            if (!oldValue) oldValue = [];

            var displayFirst = newValue.filter(function(item) { return item.displayFirst; }).sort(asc("name"));
            var displayNext = newValue.filter(function(item) { return !item.displayFirst; }).sort(asc("name"));

            var countries = displayFirst.concat(displayNext);

            countries
              .forEach(function(country) {
                lookupTables.localities(country.id)
                  .then(function(data) {
                      $scope.localities.push({ divider: true, name: country.name });
                      $scope.localities = $scope.localities.concat(data);
                    },
                    function(e) {
                      // check for error
                      var i = 0
                    });
              });

          });

        $scope.$watch("criteria.selectedLocalities.length", function () {
          if (!$scope.criteria.selectedLocalities) return;

          $scope.selectedLocalityCount = $scope.criteria.selectedLocalities.length;
          $scope.localityPlural = ($scope.selectedLocalityCount === 1) ? "y" : "ies";
        });

        // criteria.locationMode (region or country) is initially unset to
        // make the user select one or the other (this can be easily
        // given a default, depending on feedback by pre-setting it
        // to  either "region" or "country"
        // Then, watch the location mode for changes. When a change is detected,
        // clear the lists of selected regions and countries
        $scope.$watch("criteria.locationMode", function(newValue, oldValue){
          // initially the form will be invalid because no location mode has been selected
          var locationModeValidity = (newValue=="country" || newValue == "region");
          $scope.projectLocationFilterForm.projectLocation.$setValidity(null, locationModeValidity);

          if (newValue && oldValue && (newValue != oldValue))          {
            clearRegionSelections();
            clearCountrySelections();
          }
          if($scope.criteria.locationMode=='region' || $scope.criteria.locationMode == 'country'){
            $scope.requireRegion = ($scope.criteria.locationMode == 'region') ? 'yes' : 'no';
            $scope.requireCountry = ($scope.criteria.locationMode == 'country') ? 'yes' : 'no';
          }
          else{
            $scope.requireRegion = 'optional';
            $scope.requireCountry = 'optional';
          }

        });

      }])
    .directive('projectLocationFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/projectLocationFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'projectLocationFilterController'
        };
      }]);
//------------------------------------------------------------------------
